query TestDetails($runId: ConditionID!) {
	wsdk_test_runs(run_id_eq: $runId) {
		run_id
		test_name
		run_time
		total_issues
		critical_issues
		test_path
		environments
		flows
		custom_fields
		property_ids
	}
}
